import React from 'react';
import styled from 'styled-components';

const ReactDataTable = ({
  columns = [],
  rows = [],
  noDataMessage = "데이터가 없습니다.",
  highlightFields = [], // 강조 배경 필드
  boldFields = [], // 굵게 표시할 필드
}) => {
  return (
    <TableContainer>
      {rows.length > 0 ? (
        <table>
          <thead>
            <tr>
              {columns.map((col, index) => (
                <StyledTh key={index} style={{ width: col.width || 'auto' }}>
                  {col.label}
                </StyledTh>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <StyledTd
                    key={colIndex}
                    style={{ width: col.width || 'auto' }}
                    $isHighlighted={highlightFields.includes(col.field)} // 강조 배경 여부
                    $isBold={boldFields.includes(col.field)} // 굵게 표시 여부
                  >
                    {col.valueFormatter
                      ? col.valueFormatter({ value: row[col.field], row }) // valueFormatter 사용
                      : row[col.field]} {/* 포맷터 없으면 원래 값 */}
                  </StyledTd>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <NoData>{noDataMessage}</NoData>
      )}
    </TableContainer>
  );
};

export default ReactDataTable;

// ------------------------ STYLE ------------------------

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  border-radius: 4px;
  height: 270px;

  table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      text-align: left;
      padding: 8px;
      border-bottom: 1px solid #dee2e6;
    }
  }
`;

const StyledTh = styled.th`
  background-color: #f8f9fa;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 2;
`;

const StyledTd = styled.td`
  background-color: ${(props) => (props.$isHighlighted ? '#f8f9fa' : 'inherit')};
  font-weight: ${(props) => (props.$isBold ? '600' : 'normal')};
`;

const NoData = styled.div`
  padding: 40px;
  text-align: center;
  color: #999;
  font-size: 14px;
`;
